import React from 'react'
import './message.scss';
import Brand from '../brand/Brand';
import { Speaker } from '../models/enum';

type messageProps = {
    message: any,
    isHostDevice: boolean
};

const Message = ({message, isHostDevice}: messageProps) => {
    return (
        <div className="message">            
            { message.from !== Speaker.User && message.from !== Speaker.System && (
                <div className="message__brand">
                    <Brand size='small'/>
                </div>)
            }

            <div className={message.hasQr && !isHostDevice ? "message__container message__container--has-qr" : "message__container"}> 
                {
                    message.from === Speaker.System &&
                    <div className="message__system">
                        { message.icon && message.icon !== '' && <img src={ message.icon } className="message__system-icon" alt="system-icon" /> } 
                        <span className="message__system-text">{ message.text}&nbsp;{ message.shopper && message.shopper !== '' && <b>{message.shopper}</b> }</span>
                    </div>
                }

                {
                    message.from === Speaker.User &&
                    <div className="message__text message__text--user">
                        { message.text }
                    </div>
                }

                {
                    (message.from === Speaker.Murphy || message.from === Speaker.Agent || message.from === undefined || message.from === null) &&
                    <div className="message__text">
                        { message.text }
                    </div>
                }
            </div>
        </div>
    )
}

export default Message
